import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";

import HomePage from "./page/HomePage";
import AboutPage from "./page/AboutPage";
import ServicesPage from "./page/ServicesPage";
import AiAnimationPage from "./page/AiAnimationPage";
import ArtPage from "./page/ArtPage";
import ActorPage from "./page/ActorPage";

import ScrollToggleButton from "./components/ScrollToggleButton";
import ZaloButton from "./components/ZaloButton";
import PhoneCallButton from "./components/PhoneCallButton";

import "./styles/home-page.css";

function App() {
  return (
    <div className="app">
      <Header />

      <main>
        <Routes>
          <Route
            path="/"
            element={<HomePage />}
          />
          <Route
            path="/about"
            element={<AboutPage />}
          />
          <Route
            path="/services"
            element={<ServicesPage />}
          />
          <Route
            path="/ai-animation"
            element={<AiAnimationPage />}
          />
          <Route
            path="/art"
            element={<ArtPage />}
          />
          <Route
            path="/mc"
            element={<ActorPage />}
          />
        </Routes>
      </main>

      <Footer />

      {/* Floating buttons */}
      <ScrollToggleButton />
      <ZaloButton phoneNumber="0704888009" />
      <PhoneCallButton phoneNumber="0704888009" />
    </div>
  );
}

export default App;
